// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.driver-popover.driverjs-theme {
    background-color: #f8f8f8;
    color: #000;
    border-radius: 0px;
}

.driver-popover.driverjs-theme .driver-popover-title {
    font-size: 20px;
}

.driver-popover.driverjs-theme .driver-popover-title,
.driver-popover.driverjs-theme .driver-popover-description,
.driver-popover.driverjs-theme .driver-popover-progress-text {
    color: #000;
}

.driver-popover.driverjs-theme button {
    background-color: var(--button-bg-color);
    color: var(--button-text-color);
    border: 1px solid var(--border-color);
    cursor: pointer;
    outline: none;
    border-radius: 0px;
}

.driver-popover.driverjs-theme button:hover {
    background-color: var(--button-bg-color-hover);
    color: var(--button-text-color-hover);
}

.driver-popover.driverjs-theme .driver-popover-navigation-btns {
    gap: 3px;
}

.driver-popover.driverjs-theme .driver-popover-close-btn {
    background-color: #f8f8f8;
    border: none;
}

.driver-popover.driverjs-theme .driver-popover-close-btn:hover {
    background-color: #f8f8f8;
    color: black;
}

.driver-popover.driverjs-theme
    .driver-popover-arrow-side-left.driver-popover-arrow {
    border-left-color: #f8f8f8;
}

.driver-popover.driverjs-theme
    .driver-popover-arrow-side-right.driver-popover-arrow {
    border-right-color: #f8f8f8;
}

.driver-popover.driverjs-theme
    .driver-popover-arrow-side-top.driver-popover-arrow {
    border-top-color: #f8f8f8;
}

.driver-popover.driverjs-theme
    .driver-popover-arrow-side-bottom.driver-popover-arrow {
    border-bottom-color: #f8f8f8;
}
`, "",{"version":3,"sources":["webpack://./plugins/style/TourGuide.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;;;IAGI,WAAW;AACf;;AAEA;IACI,wCAAwC;IACxC,+BAA+B;IAC/B,qCAAqC;IACrC,eAAe;IACf,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,8CAA8C;IAC9C,qCAAqC;AACzC;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,4BAA4B;AAChC","sourcesContent":[".driver-popover.driverjs-theme {\n    background-color: #f8f8f8;\n    color: #000;\n    border-radius: 0px;\n}\n\n.driver-popover.driverjs-theme .driver-popover-title {\n    font-size: 20px;\n}\n\n.driver-popover.driverjs-theme .driver-popover-title,\n.driver-popover.driverjs-theme .driver-popover-description,\n.driver-popover.driverjs-theme .driver-popover-progress-text {\n    color: #000;\n}\n\n.driver-popover.driverjs-theme button {\n    background-color: var(--button-bg-color);\n    color: var(--button-text-color);\n    border: 1px solid var(--border-color);\n    cursor: pointer;\n    outline: none;\n    border-radius: 0px;\n}\n\n.driver-popover.driverjs-theme button:hover {\n    background-color: var(--button-bg-color-hover);\n    color: var(--button-text-color-hover);\n}\n\n.driver-popover.driverjs-theme .driver-popover-navigation-btns {\n    gap: 3px;\n}\n\n.driver-popover.driverjs-theme .driver-popover-close-btn {\n    background-color: #f8f8f8;\n    border: none;\n}\n\n.driver-popover.driverjs-theme .driver-popover-close-btn:hover {\n    background-color: #f8f8f8;\n    color: black;\n}\n\n.driver-popover.driverjs-theme\n    .driver-popover-arrow-side-left.driver-popover-arrow {\n    border-left-color: #f8f8f8;\n}\n\n.driver-popover.driverjs-theme\n    .driver-popover-arrow-side-right.driver-popover-arrow {\n    border-right-color: #f8f8f8;\n}\n\n.driver-popover.driverjs-theme\n    .driver-popover-arrow-side-top.driver-popover-arrow {\n    border-top-color: #f8f8f8;\n}\n\n.driver-popover.driverjs-theme\n    .driver-popover-arrow-side-bottom.driver-popover-arrow {\n    border-bottom-color: #f8f8f8;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
